import { StateHistoryModel } from 'api/models';

const FINAL_STATES = new Set(['Completed', 'CompletedWithoutMyDoka', 'Doka360AccessRequested', 'Declined', 'Aborted']);

export const getLastState = (stateHistory: StateHistoryModel[]) => stateHistory[stateHistory.length - 1];

export const isFinalState = (stateType: string) => FINAL_STATES.has(stateType);

export const isCompleted = (stateType: string) => ['Completed', 'CompletedWithoutMyDoka'].includes(stateType);

export const isDeclined = (stateType: string) => ['Declined', 'Aborted', 'Expired'].includes(stateType);

export const getActiveStepIndex = (stateHistory: StateHistoryModel[]) => {
    const last = getLastState(stateHistory);
    return isFinalState(last.stateType) ? stateHistory.length : stateHistory.length - 1;
};
